import { useEffect } from "react";

const PythonOutput = ({ output, isRunning, isHorizontal, terminalRef }) => {
  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [output]);

  return (
    <div
      className={`w-full ${isHorizontal ? "h-[67vh] lg:w-1/2" : ""} relative rounded-lg bg-white shadow-md dark:bg-[#1e272e]`}
    >
      {/* Progress bar */}
      {isRunning && (
        <div className="progress">
          <div className="progress-bar progress-bar-info progress-bar-striped active w-full"></div>
        </div>
      )}

      <div
        id="terminal"
        ref={terminalRef}
        className={`${isHorizontal ? "h-[60vh]" : "h-[30vh]"} relative w-full overflow-auto rounded-lg bg-white p-4 dark:bg-[#1e272e] ${isRunning ? "text-gray-500" : "text-black dark:text-white"}`}
      >
        {output ? <pre className="whitespace-pre-wrap">{output}</pre> : null}
      </div>
    </div>
  );
};

export default PythonOutput;
